import "./new-rate-per-pax.scss";

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormRatePerPax from "../form-rate-per-pax/form-rate-per-pax";
import { useNewRatePerPax } from "./new-rate-per-pax.hook";

export function NewRatePerPax() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewRatePerPax();

  return (
    <div id="NewRatePerPax" className="rate-per-pax">
      <HeaderContent
        title={<h1>New Rate</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormRatePerPax />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewRatePerPax;
